import create from "zustand";

const useCreatePurchaseOrderGuardStore = create((set, get) => ({
  cartHasItems: false,
  leavePromptOpen: false,
  pendingLeavePath: null,
  skipGuard: false,

  setCartHasItems: (has) => set({ cartHasItems: !!has }),

  allowNextNavigation: () => set({ skipGuard: true }),

  requestLeave: (path) => {
    const { cartHasItems, skipGuard } = get();
    if (skipGuard) {
      set({ skipGuard: false });
      return { allowed: true, path };
    }
    if (!cartHasItems) {
      return { allowed: true, path };
    }
    set({ leavePromptOpen: true, pendingLeavePath: path });
    return { allowed: false, path };
  },

  confirmLeave: () => {
    const path = get().pendingLeavePath;
    set({
      leavePromptOpen: false,
      pendingLeavePath: null,
      cartHasItems: false,
      skipGuard: true,
    });
    return path;
  },

  cancelLeave: () =>
    set({ leavePromptOpen: false, pendingLeavePath: null }),
}));

export default useCreatePurchaseOrderGuardStore;
